import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingComponent } from './landing.component';
import { TablaPreciosComponent } from './componentes/tabla-precios/tabla-precios.component';
import { LandingRoutingModule } from './landing-routes.module';
import { SharedModule } from '../shared/shared.module';
import { PromocionesComponent } from './componentes/promociones/promociones.component';
import { SucursalesComponent } from './componentes/sucursales/sucursales.component';
import { DevicesComponent } from './componentes/devices/devices.component';
import { HomeBranchesComponent } from '../components/home-branches/home-branches.component';
import { HomeBannerComponent } from '../components/home-banner/home-banner.component';
import { PromotionCardComponent } from '../components/promotion-card/promotion-card.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { HomeComponent } from './home/home.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { TerminosComponent } from './componentes/terminos/terminos.component';
import { AvisoDePrivacidadComponent } from './componentes/aviso-de-privacidad/aviso-de-privacidad.component';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TablaPreciosAuthComponent } from './componentes/tabla-precios-auth/tabla-precios-auth.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { BranchExchangeUsecase } from '../logic/branch/usecases/branch-exchange.usercase';
import { BranchRepository } from '../logic/branch/repository/branch.repository';
import { BranchImplementationRepository } from '../logic/branch/repository/branch-implementation.repository';
import { CardRailDirective } from '../shared/card-rail/card-rail.directive';

const branchExchangeUsecaseFactory = (branchRepo: BranchRepository) => new BranchExchangeUsecase(branchRepo);
export const branchExchangeUsecaseProvider = {
  provide: BranchExchangeUsecase,
  useFactory: branchExchangeUsecaseFactory,
  deps: [BranchRepository],
};

@NgModule({
  declarations: [
    LandingComponent,
    TablaPreciosComponent,
    TablaPreciosAuthComponent,
    PromocionesComponent,
    SucursalesComponent,
    DevicesComponent,
    HomeComponent,
    TerminosComponent,
    AvisoDePrivacidadComponent,
    HomeBranchesComponent,
    HomeBannerComponent,
    PromotionCardComponent,
    CardRailDirective,
  ],
  imports: [
    CommonModule,
    LandingRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    CarouselModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatSelectModule,
    MatFormFieldModule,
    MatDialogModule,
    MatTooltipModule,
    TranslateModule,
  ],
  providers: [
    branchExchangeUsecaseProvider,
    { provide: BranchRepository, useClass: BranchImplementationRepository },
  ],
})
export class LandingModule {}
